import React, { useEffect, useState } from "react";
import $ from "jquery";
import "./CarouselB2Z.css";
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import ReactPlayer from 'react-player'

export default function CarouselB2Z({lista, width, height}){
    const [numBanner, setNumBanner] = useState(0);

    useEffect(() => {
        AtualizaPosicaoImagens($(".navegacao-b2z"), 0);

        if(width)
            //$(".banner-b2z").css("max-width", width);
            $(".banner-b2z").width(width);
   
        if(height)
            //$(".banner-b2z").css("max-height", height);
            $(".banner-b2z").height(height);
    }, [lista]);
     

    //console.log($(".banner-b2z").width());
    //$(".banner-b2z .area-banner-b2z img").css("min-width", $(".banner-b2z").width());
    //$(".banner-b2z .area-banner-b2z img").css("min-width", $(".banner-b2z").height());

    const AtualizaPosicaoImagens = (obj, pos) => {
        //$(obj).parents(".banner-b2z").find(".area-banner-b2z img:first-child").css("margin-left", -($(obj).parents(".banner-b2z").find(".area-banner-b2z").width() * pos));
        $(obj).parents(".CarouselB2Z").find(".area-banner-b2z img:first-child, .area-banner-b2z iframe:first-child").css("margin-left", -($(obj).parents(".CarouselB2Z").find(".area-banner-b2z").width() * pos));
        setNumBanner(pos);
    }

    const evCliqueVoltaImagem = (e)=> {
        //console.log("ATUAL", numBanner);
        let pos = numBanner;
        let posAtual = ((pos >= 1) ? (pos - 1) : (lista.length-1));
        AtualizaPosicaoImagens(e.currentTarget, posAtual);
        //console.log("NOVO", posAtual);
        //console.log(numBanner, ($(e.currentTarget).parents(".banner-b2z").find(".area-banner-b2z").width() * numBanner));
        // $(e.currentTarget).parents(".banner-b2z").find(".area-banner-b2z img:first-child").css("margin-left", -($(e.currentTarget).parents(".banner-b2z").find(".area-banner-b2z").width() * posAtual));
        // setNumBanner(posAtual);
    }
    const evCliqueAvancaImagem = (e)=> {
        //console.log("ATUAL", numBanner);
        let pos = numBanner;
        let posAtual = ((pos < (lista.length-1)) ? pos + 1 : 0);
        //console.log("NOVO", posAtual);
        //console.log(numBanner, ($(e.currentTarget).parents(".banner-b2z").find(".area-banner-b2z").width() * numBanner));
        AtualizaPosicaoImagens(e.currentTarget, posAtual);
        // $(e.currentTarget).parents(".banner-b2z").find(".area-banner-b2z img:first-child").css("margin-left", -($(e.currentTarget).parents(".banner-b2z").find(".area-banner-b2z").width() * posAtual));
        // setNumBanner(posAtual);
    }

    window.onresize = () => {
        //console.log("RESIZE");
        AtualizaPosicaoImagens($(".navegacao-b2z"), numBanner);
        //$(".banner-b2z .area-banner-b2z img").height($(".banner-b2z").height());

        let __heigth = Math.floor(($(".banner-b2z").width()*parseInt(height)) / parseInt(width));
        $(".banner-b2z").height(__heigth);
        //console.log("__heigth", __heigth,);
    }

    const evMouseMoveIMG = (e) => {
        //console.log("evMouseMoveIMG", e.currentTarget.id, e.currentTarget.offsetLeft, e.currentTarget.offsetTop, e.currentTarget.offsetWidth, e.currentTarget.offsetHeight, e.pageX, e.pageY, e.clientX, e.clientY);
        //console.log(e.currentTarget.offsetLeft, e.currentTarget.offsetTop, e.currentTarget.offsetWidth, e.currentTarget.offsetHeight, e.pageX, e.pageY, e.clientX, e.clientY, e.screenX, e.screenY);
        
        //imageZoom(e.currentTarget.id, "#myresult");
        //imageZoom("#img0", "#myresult");
        //console.log(e.currentTarget.id);
        //imageZoom(e.currentTarget.id, `#${e.currentTarget.id}`);
        //imageZoom(e.currentTarget.id, `#${e.currentTarget.id}`);
    }
    return (
        <div className="CarouselB2Z">
            <div className="banner-b2z">
                <div className={lista.length > 1 ? "navegacao-b2z" : "navegacao-b2z display-none"}>
                    <div className="esquerda-b2z" onClick={evCliqueVoltaImagem}><ChevronLeft size={40} /></div>
                    <div className="direita-b2z" onClick={evCliqueAvancaImagem}><ChevronRight size={40} /></div>
                </div>
                <div className="area-banner-b2z">
                    {
                        lista.map((dados, index) => (
                            //console.log("dados", dados.url),
                            (dados.tipo == "mp4")
                            // ? <ReactPlayer onMouseMove={evMouseMoveIMG} url={dados.url} width="100%" height="100%" controls={false} playing={false} loop={true} muted={false} playsinline={true} light={false} /> 
                            // <iframe onMouseMove={evMouseMoveIMG} alt={`imagem-${index}`} id={`img${index}`} key={index} src={dados.url} width="100%" height="100%" frameborder="0"></iframe>
                            // ? <iframe src={dados.url} alt={`imagem-${index}`} id={`img${index}`} key={index} frameborder="0" allowfullscreen=""></iframe> 
                            ? <iframe width="1497" height="842" src={dados.url} title="CONSTRUMARCAS" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            : <img onMouseMove={evMouseMoveIMG} alt={`imagem-${index}`} id={`img${index}`} key={index} style={{background:`url(${dados.url})`}} src="/imagens/Banner_transparent.png" />
                        ))
                    }
                    {/* <div id="myresult" className="img-zoom-result"></div> */}
                </div>
            </div>
            <div className="mini-imagens">
                {
                    lista.map((dados, index) => (
                        (dados.tipo == "mp4") ?
                        <span onClick={(e) => AtualizaPosicaoImagens(e.currentTarget, index)} key={index}>vídeo</span> :
                        // <ReactPlayer key={index} url={dados.url} width="100%" height="100%" controls={false} playing={false} loop={true} muted={true} playsinline={true} light={false} /> :
                        <span key={index}><img onClick={(e) => AtualizaPosicaoImagens(e.currentTarget, index)} alt={`imagem-${index}`} style={{background:`url(${dados.url})`}} src="/imagens/Banner_transparent.png" /></span>
                    ))
                }
            </div>
        </div>
    )
}